// Подписи профессий КП (professionKey) для чипов и бейджей фильмографии
export const PROFESSION_LABELS = {
  ACTOR: 'Актёр',
  DIRECTOR: 'Режиссёр',
  WRITER: 'Сценарист',
  PRODUCER: 'Продюсер',
  PRODUCER_USSR: 'Директор фильма',
  OPERATOR: 'Оператор',
  COMPOSER: 'Композитор',
  DESIGN: 'Художник',
  EDITOR: 'Монтажёр',
  HIMSELF: 'Играет себя',
  HERSELF: 'Играет себя',
  HRONO_TITR_MALE: 'В титрах',
  HRONO_TITR_FEMALE: 'В титрах',
  VOICE_MALE: 'Озвучка',
  VOICE_FEMALE: 'Озвучка',
  TRANSLATOR: 'Переводчик',
  UNKNOWN: 'Неизвестно',
}

export function professionLabel(key) {
  return PROFESSION_LABELS[key] || key
}

// Профессии анкеты (poiskkino/КП, по-русски) → ключи фильмографии КП. Озвучка и «играет себя» — по два ключа (м/ж)
const TITLE_KEYS = [
  [/дубляж|озвуч/, ['VOICE_MALE', 'VOICE_FEMALE']],
  [/актер|актрис/, ['ACTOR']],
  [/режисс/, ['DIRECTOR']],
  [/сценар/, ['WRITER']],
  [/директор фильма/, ['PRODUCER_USSR']],
  [/продюс/, ['PRODUCER']],
  [/оператор/, ['OPERATOR']],
  [/композит/, ['COMPOSER']],
  [/художн/, ['DESIGN']],
  [/монтаж/, ['EDITOR']],
  [/перевод/, ['TRANSLATOR']],
  [/играет себя|в роли себя/, ['HIMSELF', 'HERSELF']],
]

export function professionKeysByTitle(title) {
  const normalized = String(title).toLowerCase().replace(/ё/g, 'е')
  const match = TITLE_KEYS.find(([pattern]) => pattern.test(normalized))
  return match ? match[1] : []
}
